import { Divider, Typography, Grid2 as Grid } from "@mui/material";
import { FC } from "react";
import { renderLabeledValues } from "src/shared/helpers/render.helpers";
import { IPartnerDto } from "src/shared/types/partner.types";

interface IOperationProps {
  partner: IPartnerDto;
}

export const Operation: FC<IOperationProps> = ({ partner }) => {
  const {
    region,
    activity_spheres,
    easy_service,
    easy_service_phone,
    carrot_quest,
    is_in_blacklist,
  } = partner;

  return (
    <Grid container spacing={2}>
      <Grid size={12}>
        <Divider />
      </Grid>

      <Grid size={12}>
        <Typography component="span" sx={{ color: "grey.500" }}>
          Деятельность
        </Typography>
      </Grid>

      {renderLabeledValues([
        { label: "Регион", value: region },
        {
          label: "Сфера деятельности",
          value: (activity_spheres ?? []).map((item) => item.name).join(", "),
        },
        { label: "Easy Service", value: easy_service?.name ?? "—" },
        { label: "Carrot Quest", value: carrot_quest?.name ?? "—" },
        { label: "Телефония", value: easy_service_phone?.name ?? "—" },
        { label: "Black list", isSuccess: is_in_blacklist },
      ])}
    </Grid>
  );
};
